import { defineComponent, computed, renderSlot } from 'vue';
import { RenderStrategyPropsProvider } from '../../utils/use-render-strategy.js';
import { useForwardExpose } from '../../utils/use-forward-expose.js';
import { HoverCardProvider } from './use-hover-card-context.js';

const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "hover-card-root-provider",
  props: {
    value: {},
    lazyMount: { type: Boolean },
    unmountOnExit: { type: Boolean }
  },
  setup(__props) {
    const props = __props;
    const hoverCard = computed(() => props.value);
    HoverCardProvider(hoverCard);
    RenderStrategyPropsProvider(computed(() => ({ lazyMount: props.lazyMount, unmountOnExit: props.unmountOnExit })));
    useForwardExpose();
    return (_ctx, _cache) => {
      return renderSlot(_ctx.$slots, "default");
    };
  }
});

export { _sfc_main as default };
